import Image from "next/image";
import { Button } from "@/components/ui/button";
import Link from "next/link";

const data = [
  {
    title:
      "PERSEPSI MASYARAKAT ATAS KEBIJAKAN PEMENSIUNAN DINI PLTU BATU BARA DALAM TRANSISI ENERGI",
    image:
      "/images/publications/Persepsi Masyarakat atas Kebijakan Pemensiunan Dini PLTU Batu Bara dalam Transisi Energi_Cerah-Poldev (4)-1_page-0001.jpg",
    file: "https://drive.google.com/file/d/1bx4GYkC0WTerSsDaz3ClSKFGODGp-0sX/view?usp=drive_link",
  },
  {
    title: "Keterjangkauan Harga Perumahan di Indonesia",
    image: "/images/publications/id_survei_properti-1_pages-to-jpg-0001.jpg",
    file: "https://drive.google.com/file/d/1cpviYH22Z6Gwnrgd3YaoFjBPTS4_Dl11/view?usp=drive_link",
  },
  {
    title: "Menuju Transisi Energi: Pesan Rakyat Untuk Presiden Masa Depan",
    image:
      "/images/publications/id_menuju_transisi_energi_pesan_rakyat_untuk_presiden_masa_depan-1_pages-to-jpg-0001.jpg",
    file: "https://drive.google.com/file/d/1jXte4qW5RjCNmerWi3wroOiU_26WYOWx/view?usp=drive_link",
  },
  {
    title:
      "SURVEI NASIONAL OPINI PUBLIK TERKAIT JUST ENERGY TRANSITION PARTNERSHIP (JETP)",
    image:
      "/images/publications/id_survei_nasional_opini_publik_terkait_just_energy_transition_partnership-1_page-0001.jpg",
    file: "https://drive.google.com/file/d/1Xfi0XGG8hu-QoAtKM2Prg4vsh6VAZ16O/view?usp=drive_link",
  },
];

export default function HomePub() {
  // const fetchProjects = () =>
  //   fetchStrapiAPI(`/publications`, {
  //     sort: { createdAt: "desc" },
  //     populate: {
  //       Cover: {
  //         url: true,
  //       },
  //       File: {
  //         url: true,
  //       },
  //       title: true,
  //     },
  //   });

  // const { data, error, isFetching, status } = useQuery({
  //   queryKey: ["publications"],
  //   queryFn: fetchProjects,
  // });

  return (
    <div className="p-10 lg:px-0">
      <div className="lg:min-h-[35rem] h-full lg:bg-[url('/images/logo-unitrend.png')] bg-no-repeat bg-center bg-cover">
        <div className="pt-10 lg:pt-24">
          <h2 className="text-2xl text-gray-500 text-center">Publikasi Kami</h2>
        </div>

        {data && (
          <ul className="w-full grid grid-cols-2 lg:grid-cols-4 max-w-5xl mx-auto gap-5 mt-10">
            {data &&
              data.map((pub: any, index: number) => (
                <li
                  key={index}
                  className="rounded-md outline overflow-hidden bg-white"
                  data-aos="fade-up"
                >
                  <div className="flex justify-center">
                    <div className="w-full aspect-w-12 aspect-h-16 relative">
                      <Image
                        src={`${pub.image}`}
                        width={256}
                        height={512}
                        alt={`Cover of ${pub.title}`}
                      />
                    </div>
                  </div>

                  {pub.file && (
                    <Link href={`${pub.file}`}>
                      <Button className="w-full rounded-none ">
                        Lihat&nbsp;Publikasi
                      </Button>
                    </Link>
                  )}
                </li>
              ))}
          </ul>
        )}

        <p className=" max-w-5xl mx-auto text-sm font-light bg-white my-10 text-justify text-slate-700">
          Unitrend telah melakukan berbagai riset yang mendalam di bidang
          transisi energi dan politik di Indonesia. Publikasi komprehensif kami
          mencakup analisis mendetail mengenai perubahan kebijakan energi,
          dampak sosial-ekonomi, serta dinamika politik yang memengaruhi sektor
          energi. Dengan fokus pada isu-isu kritis dan solusi praktis, riset
          kami memberikan wawasan yang berharga bagi para pengambil keputusan
          dan peneliti di bidang ini. Unitrend berkomitmen untuk menjadi sumber
          terpercaya dalam memahami dan mengarahkan transisi energi di
          Indonesia.
        </p>
      </div>
    </div>
  );
}
